"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectUserPersona = exports.makeSelectActionTrackingItemsToBeAcknowledged = exports.makeSelect = exports.makeSelectClaimLocation = exports.makeSelectShowTodo = exports.makeSelectEntitlementStatus = exports.makeSelectDept = exports.makeSelectProfileImage = exports.makeSelectBrands = exports.makeSelectAppTokenToDo = exports.makeSelectAppToken = exports.makeSelectUserAppFunctions = exports.makeSelectMenus = exports.makeSelectUserInfo = exports.makeSelectAuthenticated = exports.makeSelectPerId = exports.makeSelectIsSidenavCollapsed = exports.makeSelectLoading = exports.makeSelectJwtTokenSN = exports.makeSelectUserSession = exports.selectContainer = void 0;

var _reselect = require("reselect");

var _baseLayout = require("./base-layout.reducer");

var _baseLayout2 = require("./base-layout.constants");

/**
 * Homepage selectors
 */
var selectContainer = function selectContainer(state) {
  return state.get(_baseLayout2.key, _baseLayout.initialState);
};

exports.selectContainer = selectContainer;

var makeSelectUserSession = function makeSelectUserSession() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("cacheKeyDetails");
  });
};

exports.makeSelectUserSession = makeSelectUserSession;

var makeSelectJwtTokenSN = function makeSelectJwtTokenSN() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("JwtTokenSN");
  });
};

exports.makeSelectJwtTokenSN = makeSelectJwtTokenSN;

var makeSelectLoading = function makeSelectLoading() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("loading");
  });
};

exports.makeSelectLoading = makeSelectLoading;

var makeSelectIsSidenavCollapsed = function makeSelectIsSidenavCollapsed() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("isSidenavCollapsed");
  });
};

exports.makeSelectIsSidenavCollapsed = makeSelectIsSidenavCollapsed;

var makeSelectPerId = function makeSelectPerId() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    var _homeState$get;

    var perId = (_homeState$get = homeState.get("userinfo")) === null || _homeState$get === void 0 ? void 0 : _homeState$get.personId;
    return homeState.get("perId") || perId;
  });
};

exports.makeSelectPerId = makeSelectPerId;

var makeSelectAuthenticated = function makeSelectAuthenticated() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("authenticated");
  });
};

exports.makeSelectAuthenticated = makeSelectAuthenticated;

var makeSelectUserInfo = function makeSelectUserInfo() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("userinfo");
  });
};

exports.makeSelectUserInfo = makeSelectUserInfo;

var makeSelectMenus = function makeSelectMenus() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("menus");
  });
};

exports.makeSelectMenus = makeSelectMenus;

var makeSelectUserAppFunctions = function makeSelectUserAppFunctions() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("userAppFunctions");
  });
};

exports.makeSelectUserAppFunctions = makeSelectUserAppFunctions;

var makeSelectAppToken = function makeSelectAppToken() {
  return (0, _reselect.createSelector)(makeSelectUserAppFunctions(), function (userAppFunctions) {
    return userAppFunctions.jwtToken;
  });
};

exports.makeSelectAppToken = makeSelectAppToken;

var makeSelectAppTokenToDo = function makeSelectAppTokenToDo(appName) {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    if (null != homeState.get("userinfo") && null != homeState.get("userinfo").roles) {
      var app = homeState.get("userinfo").roles.filter(function (role) {
        return role.appName === appName;
      });
      if (app.length) return app[0].jwtToken;
    }
  });
};

exports.makeSelectAppTokenToDo = makeSelectAppTokenToDo;

var makeSelectBrands = function makeSelectBrands() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("userBrands");
  });
};

exports.makeSelectBrands = makeSelectBrands;

var makeSelectProfileImage = function makeSelectProfileImage() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("profileImage");
  });
};

exports.makeSelectProfileImage = makeSelectProfileImage;

var makeSelectDept = function makeSelectDept() {
  return (0, _reselect.createSelector)(makeSelectUserInfo(), function (userinfo) {
    return userinfo ? userinfo.Dept : null;
  });
};

exports.makeSelectDept = makeSelectDept;

var makeSelectEntitlementStatus = function makeSelectEntitlementStatus() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get(_baseLayout2.ENTITLEMENT_STATUS);
  });
};

exports.makeSelectEntitlementStatus = makeSelectEntitlementStatus;

var makeSelectShowTodo = function makeSelectShowTodo() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("showTodo");
  });
};

exports.makeSelectShowTodo = makeSelectShowTodo;

var makeSelectClaimLocation = function makeSelectClaimLocation() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("rdsLocation");
  });
};

exports.makeSelectClaimLocation = makeSelectClaimLocation;

var makeSelect = function makeSelect(name) {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get(name);
  });
};

exports.makeSelect = makeSelect;

var makeSelectActionTrackingItemsToBeAcknowledged = function makeSelectActionTrackingItemsToBeAcknowledged() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("loadingActionTrackingItemsToBeAcknowledged");
  });
};

exports.makeSelectActionTrackingItemsToBeAcknowledged = makeSelectActionTrackingItemsToBeAcknowledged;

var makeSelectUserPersona = function makeSelectUserPersona() {
  return (0, _reselect.createSelector)(selectContainer, function (homeState) {
    return homeState.get("userPersona");
  });
};

exports.makeSelectUserPersona = makeSelectUserPersona;